import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RxUtils, Tr } from '@utils';
import { useService } from '@hooks';
import {
	CarModel,
	dealerConfigService,
	fleetVehicleService,
	notificationService,
	NotificationType,
	simulationService,
	SimulationTask
} from '@services';
import { Button, IconButton, Typography } from '@mui/material';
import { CarModelInfo, SuggestionLayout } from '@components/portal/conversion-list';
import CloseIcon from '@mui/icons-material/Close';

export const SingleSuggestion: FC = () => {
	const { t } = useTranslation('portal');
	const navigate = useNavigate();
	const { taskId = '' } = useParams<{ taskId: string }>();
	const [task, setTask] = useState<SimulationTask | undefined>();
	const [selectedModel, setSelectedModel] = useState<CarModel | undefined>();
	const { data: simulationTasks = [] } = useService(() => simulationService.getLatestSimulationTasks(), []);
	const { data: dealerConfig } = useService(() => dealerConfigService.find(), []);
	useEffect(() => setTask(simulationTasks.find(({ id }) => id === taskId)), [simulationTasks]);
	useEffect(() => setSelectedModel(task?.fleetVehicle?.selectedCarModel), [task]);

	return (
		<SuggestionLayout
			task={task}
			selectedCarModels={selectedModel ? [selectedModel] : undefined}
			vehiclePriceVisible={dealerConfig?.isVehiclePriceVisible}
			onSelectedCarModelChange={(model, action) => setSelectedModel(action === 'select' ? model : undefined)}
			title={<Tr.Portal path="conversion-list.vehicle-comparison.single.title" />}
			topRight={
				<IconButton sx={{ color: 'common.black' }} onClick={() => navigate(-1)}>
					<CloseIcon color="inherit" fontSize="large" />
				</IconButton>
			}
			left={
				task ? (
					<CarModelInfo
						mode="self"
						vehicle={task?.fleetVehicle}
						vehiclePriceVisible={dealerConfig?.isVehiclePriceVisible}
						title={
							<Typography variant="h4" sx={{ fontWeight: 600, marginTop: 3, marginBottom: 4, textAlign: 'center' }}>
								<Tr.Portal path="conversion-list.vehicle-comparison.single.current-vehicle-consumption" />
							</Typography>
						}
					/>
				) : null
			}
			cta={
				<Button
					data-testid="conversion-list-single-suggestion-assign-button"
					variant="contained"
					color="primary"
					sx={{ width: 200 }}
					disabled={!selectedModel}
					onClick={() =>
						task?.fleetVehicle &&
						selectedModel &&
						RxUtils.promisify(
							fleetVehicleService.selectSolution(task.fleetVehicle.id, selectedModel.id),
							() => {
								notificationService.send({
									type: NotificationType.SUCCESS,
									message: t('conversion-list.vehicle-comparison.single.assignment-succesfull')
								});
								navigate(-1);
							},
							() => RxUtils.noop
						)
					}
				>
					<Tr.Portal path="assign" />
				</Button>
			}
		/>
	);
};
